<div class="tooltip-with-title">
  <div class="tooltip-with-title__title">{{ titleKey() | translate }}</div>
  <div class="tooltip-with-title__body">{{ bodyKey() | translate }}</div>
</div>
